import { Injectable } from '@angular/core';
import { EmissionDesignatorSortModel } from './models/emission-designator-sort-model';

@Injectable({
    providedIn: 'root',
})
export class EmissionDesignatorSortingService {
    /**
     * Sorts the emission designators by bandwidth in descending order.
     * @param emissionDesignators
     * @returns the sorted emission designators
     */
    sortByBandwidthDescending(
        emissionDesignators: EmissionDesignatorSortModel[],
    ): EmissionDesignatorSortModel[] {
        return [...emissionDesignators].sort((a, b) => {
            const bandwidthA = this.getBandwidth(a.emissionDesignatorCode);
            const bandwidthB = this.getBandwidth(b.emissionDesignatorCode);
            return bandwidthB - bandwidthA;
        });
    }

    private getBandwidth(code: string): number {
        return parseFloat(code.substring(0, 4).replace(/\D/g, '.'));
    }
}
